import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { CompleteAnim, MplButton, MplModal } from '@mopla/ui';

interface IDTicketPauseSuccessModalProps {
	open: boolean;
	onClose: () => void;
	activeFromDate: string;
}

const transComponents = {
	b: <Typography variant="b2-m" component="span" color="primary.main" />,
};

export const DTicketPauseSuccessModal = ({
	open,
	onClose,
	activeFromDate,
}: IDTicketPauseSuccessModalProps) => {
	const { t } = useTranslation('dticketSubscriptionPause');

	const description = (
		<Typography
			variant="b2"
			color="primary.main"
			data-testid="dticket-pauseSuccessModal-description"
		>
			<Trans
				t={t}
				i18nKey="success_modal.description"
				values={{ date: activeFromDate }}
				components={transComponents}
			/>
		</Typography>
	);

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionPause-SuccessModal"
			icon={<CompleteAnim />}
			title={t('success_modal.title')}
			content={description}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId="dticket-pauseSuccessModal-close-button"
				>
					{t('success_modal.button')}
				</MplButton>
			}
		/>
	);
};
